module.exports = "<div class=row> <div class=col-xs-12> <app-form-text view-state=true multiline=true i18n-label=\"Description Summer\" field=poi.description_summer main-lang=poi.main_lang></app-form-text> </div> </div> <div class=row> <div class=col-xs-12> <app-form-text view-state=true multiline=true i18n-label=\"Description Winter\" field=poi.description_winter main-lang=poi.main_lang></app-form-text> </div> </div> ";


//////////////////
// WEBPACK FOOTER
// /app/suissealpine/static/app/poi/view/general/partial_descriptions.html
// module id = 452
// module chunks = 0